import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Icon } from 'assets/Icons/24px/personal-Information.svg';

function PersonalInformationOutlinedIcon(props: SvgIconProps) {
  return (
    <SvgIcon component={Icon} viewBox="0 0 24 24" {...props} />
  );
}

export default PersonalInformationOutlinedIcon;